import { aiInstructionTableResponseSchema, aiInstructionFilterOptionsQuerySchema, aiInstructionFilterOptionsResponseSchema, listAiInstructionsDataTableParamsSchema, } from '../contracts/ai-instructions';
import { serializeTableQueryParams } from '../contracts/table';
import { parseSchema } from '../errors';
import { organizationIdSchema, } from '../contracts/organizations';
/**
 * Fetch AI instructions in DataTable format (pagination, filters, sorting, search).
 *
 * Sends filters using bracket notation via serializeTableQueryParams.
 * The response follows the standard DataTable shape: { data, pagination, meta }.
 *
 * @param client - Axios client instance
 * @param organizationId - Organization ID
 * @param params - DataTable query parameters
 * @param options - Optional AbortSignal for request cancellation
 */
export async function listAiInstructionsDataTable(client, organizationId, params = {}, options) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(listAiInstructionsDataTableParamsSchema, params);
    const response = await client.get(`/organizations/${validatedId}/ai-instructions/datatable`, {
        params: validatedParams,
        paramsSerializer: serializeTableQueryParams,
        signal: options?.signal,
    });
    return parseSchema(aiInstructionTableResponseSchema, response);
}
/**
 * Get distinct filter option values for an AI instruction field.
 * Supported fields: name, file, projects.
 *
 * @param client - Axios client instance
 * @param organizationId - Organization ID
 * @param params - Query parameters including field, search, limit, offset
 */
export async function getAiInstructionFilterOptions(client, organizationId, params) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(aiInstructionFilterOptionsQuerySchema, params);
    const response = await client.get(`/organizations/${validatedId}/ai-instructions/filter-options`, { params: validatedParams });
    return parseSchema(aiInstructionFilterOptionsResponseSchema, response);
}
//# sourceMappingURL=ai-instructions.js.map